import { Component, OnInit, Input } from '@angular/core';
import { BaseCommonComponent, UserService, BaseDataService, ModalService, BaseModalUpdateComponent, ModalContainerService, BaseUpdateComponent, ModelData, TableRowColor, ConditionType, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SpisakDokumenata } from './spisak-dokumenata';
import { VezaDok } from 'src/app/lookups/veza-dok/veza-dok';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { OdabirDokumenata } from './odabir-dokumenta';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-odabir-avansa',
  templateUrl: './odabir-avansa.component.html'
})
export class OdabirAvansaComponent implements OnInit {

  constructor(
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService
    protected toastrService: NotificationService
  )
  {
    
  }
  Config={};
  items = [];
  modelData: ModelData;
  @Input() Parameters;
  itemVezaDok: VezaDok = <VezaDok>{};
  rowColors: TableRowColor[];
  odabirDokumenta: OdabirDokumenata = <OdabirDokumenata>{};
  @Input() legends = [
    {name: 'LEGENDA.ISTIOBJEKAT', color: '#fed9ca'},
    {name: 'LEGENDA.POSTOJIVEZA', color: '#BEBEBE'}
  ];

  ngOnInit() {
    this.odabirDokumenta["FakDokumentID"]=this.Parameters[0].Value;
    this.odabirDokumenta["Url"]=this.Parameters[1].Value;
    this.baseDataService.Post('OdabirDokumenata','GetDokumenteByFakDokumentID',this.odabirDokumenta,SpisakDokumenata)
    .subscribe(data => {
      this.items = data;
      this.Config={
        EditIcon: {
          Visible: false
        },
        DeleteIcon: {
          Visible: false
        },
        DefaultSortKey: this.modelData.MainList.SortBy,
        DefaultSortReverse: this.modelData.MainList.SortReverse,
        ShowIndex: false,
        ShowDefaultListButtons: false,
        ShowCheckBoxes: true,
        PrintIcon: {
          Visible: false
        }
        ,BreadCrumble: this.modelData.BreadcrumbLabel
      }
    });
  }

  ngAfterContentInit(){
    this.rowColors = [    
      { 
        ColumnName: 'ObjekatID',
        Condition: ConditionType.Equals,
        Value: this.Parameters==undefined ? 0 : this.Parameters[3].Value==null ? 0 : this.Parameters[3].Value,
        Color: '#fed9ca'
      },
      { 
        ColumnName: 'VezaDokID',
        Condition: ConditionType.GreaterThan,
        Value: 0,
        Color: '#BEBEBE'
      }
    ];
  }

  async SaveOld(){
    let numberOfChecked: number = 0;
    let numberOfDeChecked: number = 0;
    let numberOfSaved: number = 0;
    if (this.items){
      for(const item of this.items){
        await new Promise<void>((resolve, reject) =>{
          if (item.Checked){
            numberOfChecked++;
            this.itemVezaDok["TataMasterDokumID"]=this.Parameters[2].Value;
            this.itemVezaDok["DeteMasterDokumID"]=item.MasterDokumID;
            this.SaveInVezaDok(this.itemVezaDok, item.VezaDokID)
            .subscribe((result) =>{
              if (item.VezaDokID!=result){
                numberOfSaved++;
                // this.notificationService.success("Uspešno", "Sačuvana veza sa avansom broj: "+item.Broj);
                this.toastrService.success("Uspešno", "Sačuvana veza sa avansom broj: "+item.Broj);
              }
              resolve();
            });
          }
          else if (!item.Checked && item.VezaDokID != 0){
            //brisanje
            numberOfDeChecked++;
            this.DeleteInVezaDok(item.VezaDokID).subscribe(() =>{
              // this.notificationService.success("Brisanje","Obrisana je veza sa dokumentom broj: "+item.Broj);
              this.toastrService.success("Brisanje","Obrisana je veza sa dokumentom broj: "+item.Broj);
              resolve();
            });            
          }
          else
            resolve();
        })
      }
    }
    else  
      this.toastrService.success("Info","Nema ništa za snimanje.");

    this.activeModal.close(true);
  }

  Save(){
    let fakdokumentID : number = this.Parameters[0].Value;
    let checkedIDs : string = "";
    let genericName : string = "";
    let genericNameArray = [];
    if (this.items){
      for(const item of this.items){
        genericNameArray = this.items.map(item => item.GenericName)
        .filter((value, index, self) => self.indexOf(value) === index)
        // genericName += item.GenericName + ",";
        if (item.Checked){
          checkedIDs += item.ID + ",";
        }
      }
      genericName = genericNameArray.toString();
      checkedIDs = checkedIDs.substring(0,checkedIDs.length - 1);
      if (checkedIDs != ""){        
      // genericName = genericName.substring(0, genericName.length - 1);
      this.baseDataService.Post("FakDokument","SavePovezivanjeDokumenata",{'FakDokumentID' : fakdokumentID, 'PovezaniDokumentiIDs' : checkedIDs, 'GenericName' : genericName, 'DodajStavke' : false} ,null)
        .subscribe(()=>{
          // this.notificationService.success("Uspešno", "Sačuvane veze sa dokumentom.");
          this.toastrService.success("Uspešno", "Sačuvane veze sa dokumentom.");
          this.activeModal.close(true);  
        })
      }
      else{
        this.baseDataService.Post("FakDokument","SavePovezivanjeDokumenata",{'FakDokumentID' : fakdokumentID, 'PovezaniDokumentiIDs' : checkedIDs, 'GenericName' : genericName, 'DodajStavke' : false} ,null)
        .subscribe(()=>{
        // this.notificationService.info("Info", "Nije odabran avans.");
        this.toastrService.info("Info", "Nije odabran avans.");
        this.activeModal.close(true);  
        });
      }

    }
  }


  SaveInVezaDok(itemVezaDok:VezaDok, vezaDokID:number):Observable<number>{
    if (vezaDokID==0){
      return this.baseDataService.Post("vezadok","post",itemVezaDok,null)
      .pipe(map(result =>{
        return result["ID"];
      }));
    }
    else{
      return of(vezaDokID);
    }
  
  }

  DeleteInVezaDok(vezaDokID:number):Observable<any>{
    return this.baseDataService.Delete("vezadok",vezaDokID)
        .pipe();
   
  }

  Close(){
    this.activeModal.dismiss();
  }

}
